import omit from 'lodash.omit';
import { jobsSelector } from 'store/results/results';
import { userTokenSelector } from 'store/user/user';
import createApiClient from 'seek-jobs-api-client';
const api = createApiClient();

const SAVE_JOB_BEGIN = 'SAVE_JOB_BEGIN';
export const SAVE_JOB_SUCCESS = 'SAVE_JOB_SUCCESS';
const SAVE_JOB_ERROR = 'SAVE_JOB_ERROR';
const REMOVE_SAVE_JOB_BEGIN = 'REMOVE_SAVE_JOB_BEGIN';
export const REMOVE_SAVE_JOB_SUCCESS = 'REMOVE_SAVE_JOB_SUCCESS';
const REMOVE_SAVE_JOB_ERROR = 'REMOVE_SAVE_JOB_ERROR';
export const SAVED_JOBS_SEARCH_SUCCESS = 'SAVED_JOBS_SEARCH_SUCCESS';

const initialState = {
  jobs: {}
};

const getJobTrackingProps = (jobs, jobId) => {
  let position = 0, displayType = 'ad-type unknown';

  jobs.forEach(job => {
    if (job.id === jobId) {
      position = job.queryString.pos;
      displayType = job.queryString.type;
    }
  });

  return {
    position,
    displayType
  };
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case REMOVE_SAVE_JOB_BEGIN:
    case SAVE_JOB_ERROR: {
      const { jobId } = action.payload;
      const jobs = { ...omit(state.jobs, jobId) };

      return {
        ...state,
        jobs
      };
    }

    case SAVE_JOB_BEGIN:
    case REMOVE_SAVE_JOB_ERROR: {
      const { jobId } = action.payload;
      const newJob = { [jobId]: 'saved' };
      const jobs = { ...state.jobs, ...newJob };

      return {
        ...state,
        jobs
      };
    }

    case SAVED_JOBS_SEARCH_SUCCESS: {
      const { savedJobs } = action.payload;
      const jobs = { ...state.jobs, ...savedJobs };

      return {
        ...state,
        jobs
      };
    }

    default: {
      return state;
    }
  }
}

export const saveJob = (jobId, triggeredByIntent = false) => (dispatch, getState) => {
  const state = getState();
  const jobs = jobsSelector(state);
  const token = userTokenSelector(state);
  const trackingProps = getJobTrackingProps(jobs, jobId);

  dispatch({
    type: SAVE_JOB_BEGIN,
    payload: { jobId },
    meta: { hotjar: `Saved Job${triggeredByIntent ? ' Logged Out' : ''}` }
  });

  return api.candidate.saveJob(jobId, token)
    .then(() => dispatch({
      type: SAVE_JOB_SUCCESS, payload: { jobId, ...trackingProps } // trackingProps used for analytics tracking
    }))
    .catch(err => dispatch({
      type: SAVE_JOB_ERROR, error: true, payload: err
    }));
};

export const removeSavedJob = jobId => (dispatch, getState) => {
  const state = getState();
  const jobs = jobsSelector(state);
  const token = userTokenSelector(state);
  const trackingProps = getJobTrackingProps(jobs, jobId);

  dispatch({
    type: REMOVE_SAVE_JOB_BEGIN,
    payload: { jobId },
    meta: { hotjar: 'Saved Job Removed' }
  });

  return api.candidate.removeSavedJob(jobId, token)
    .then(() => dispatch({
      type: REMOVE_SAVE_JOB_SUCCESS, payload: { jobId, ...trackingProps } // trackingProps used for analytics tracking
    }))
    .catch(err => dispatch({
      type: REMOVE_SAVE_JOB_ERROR, error: true, payload: err
    }));
};

export const savedJobSearch = () => (dispatch, getState) => {
  const { user: userStore, results } = getState();
  const { token } = userStore;
  const { jobIds } = results;

  if (jobIds.length > 0) {
    return api.candidate.searchSavedJobs(jobIds, token).then(result => {
      dispatch({
        type: SAVED_JOBS_SEARCH_SUCCESS,
        payload: result
      });
    });
  }
  return null;
};



/** WEBPACK FOOTER **
 ** ./app/store/savedJobs/savedJobs.js
 **/